const paths = {
  "/": "Recibidos",
  "/oficios/new": "Crear oficio",
  "/oficios/:id?": "Oficio",
  "/recibidos": "Recibidos",
  "/borradores": "Borradores",
  "/enviados": "Enviados",
  "/login": "Iniciar sesión",
  "/busqueda": "Búsqueda",
  "/configuraciones":"Configuraciones",
  "/permisos":"Permisos",
  "/crear":"Crear Oficio",
  "/delegar": "Delegar",
  "/manuales": "Manuales",
};
export default path => {
  if (path.search(/oficios\/\d+/) !== -1) path = "/oficios/:id?";
  const name = paths[path] || "";
  return name;
};



// WEBPACK FOOTER //
// ./src/PathToName.js